// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__2x3yK","recaptcha":"styles_recaptcha__3uzBf"};